
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_packing)"}},[_c('path',{attrs:{"d":"M62.368 43.79h-8.72V29.56c0-.514-.419-.93-.937-.93a.934.934 0 00-.937.93V43.79h-16.29V39.76c0-.514-.42-.93-.938-.93h-9.414V16.653h10.647v3.827c0 .819.672 1.485 1.497 1.485h2.353c.826 0 1.498-.666 1.498-1.485v-3.827h10.647v9.186c0 .514.42.93.937.93a.934.934 0 00.938-.93v-9.427c0-.893-.732-1.62-1.633-1.62H32.285V1.65c0-.893-.733-1.62-1.633-1.62H13.434c-.9 0-1.633.727-1.633 1.62V7.53c0 .514.42.93.938.93a.934.934 0 00.937-.93V1.89h5.693v3.827c0 .819.672 1.485 1.497 1.485h2.353c.826 0 1.497-.666 1.497-1.485V1.89h5.694v12.904h-6.215a.934.934 0 00-.938.93v7.752h-9.58V11.249c0-.514-.42-.93-.938-.93a.934.934 0 00-.938.93v12.227h-5.52c-.9 0-1.632.726-1.632 1.62v13.733H1.632c-.9 0-1.632.727-1.632 1.62v22.106c0 .514.42.93.938.93h9.926a.934.934 0 00.938-.93c0-.514-.42-.93-.938-.93H1.875V40.69h13.193v3.827c0 .819.672 1.485 1.497 1.485h2.353c.826 0 1.497-.666 1.497-1.485V40.69h13.193v20.935H14.613a.934.934 0 00-.938.93c0 .514.42.93.938.93h48.45a.934.934 0 00.937-.93V45.41c0-.893-.732-1.62-1.632-1.62zM22.84 5.342h-1.597V1.89h1.597V5.34zm16.41 11.313v3.452h-1.597v-3.452h1.597zm-25.16 8.682h1.598v3.452h-1.597v-3.452zm-7.567 0h5.693v3.827c0 .82.671 1.485 1.497 1.485h2.353c.825 0 1.497-.666 1.497-1.485v-3.827h5.693V38.83H6.524V25.336zM18.54 44.142h-1.597V40.69h1.597v3.452zm31.063 1.51v3.45h-1.597v-3.45h1.597zm12.522 15.973H35.483V45.651h10.648v3.827c0 .819.671 1.485 1.497 1.485h2.353c.825 0 1.497-.666 1.497-1.485V45.65h10.647v15.974z","fill":"#1BA7E1"}})])])
          )
        }
      }
    